import cloneDeep from 'lodash.clonedeep'
import ImageFilePreviewLoader from '../Images/ImageFilePreviewLoader.js'

const imageThumbnailLoader = new ImageFilePreviewLoader()

export class FileWrapper {
  constructor () {
    this.type = null
    this.isToUpload = false
    this.isToDelete = false
    this.selected = false
    this.uploadError = null // только для документов ?
    this.$node = null // Для представления в виде дерева или списка
    this.props = { // Для доп. параметров
      warnings: []
    }
  }

  get _node () {
    if (!this.$node) {
      this.$node = createFileNode(this)
    }
    return this.$node
  }

  checkDuplicate (fileWrapperAnother) {
    if (this !== fileWrapperAnother) {
      if (this.originalHash && this.originalHash === fileWrapperAnother.originalHash) {
        return true
      }
      // if (this.name === fileWrapperAnother.name) {
      //   return this.createTime === fileWrapperAnother.createTime
      // }
    }
    return false
  }
}

export class FileDocument extends FileWrapper {
  constructor (documentOrFile, config, folderIndex) {
    super()

    this.type = 'file' // раньше устанавливалось только для File
    this.url = null

    this.originalTime = null
    this.originalHash = null
    this.attributes = null
    this.ignoreDuplicate = false
    this._name = null // TODO FileDocument - name

    if (documentOrFile instanceof File) { // При добавлении нового файла, еще не загруженного на сервер
      this.isToUpload = true
      const file = documentOrFile
      this.file = file

      file.blob = ''
      const URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        file.blob = URL.createObjectURL(file)
      }
      this.url = file.blob

      file.thumb = ''
      if (file.blob && file.type.startsWith('image/')) {
        file.thumb = file.blob
      }

      if (config.originalTime) {
        this.originalTime = config.originalTime
      }
      if (config.originalHash) {
        this.originalHash = config.originalHash
      }
      if (config.attributes) {
        this.attributes = config.attributes
      }
      if (config.ignoreDuplicate != null) {
        this.ignoreDuplicate = config.ignoreDuplicate
      }
      this.onSuccess = config.onSuccess
      this.onFailure = config.onFailure
    } else {
      const document = documentOrFile
      this.document = document

      if (folderIndex != null && document.foldersIds) {
        this.folderIndex = folderIndex
        this.folderId = document.foldersIds[folderIndex]
        this.folderFileName = document.foldersFilesNames ? document.foldersFilesNames[folderIndex] : ''
        this.folderPath = document.foldersPathes ? document.foldersPathes[folderIndex] : ''
      }

      this.url = '/service/delta/document/read?id=' + document.id + (document.relId ? '&relId=' + document.relId : '')
      this.smallUrl = '/service/delta/document/thumbnail/' + document.id + '/140/140'
      this.smallBlob = null

      if (document) {
        this.documentInitial = cloneDeep(document)

        // TODO originalTime ?
        if (document.originalHash) {
          this.originalHash = document.originalHash
        }
        if (document.attributes) {
          this.attributes = this.document.attributes
        }
        if (document.ignoreDuplicate != null) {
          this.ignoreDuplicate = this.document.ignoreDuplicate
        }
      }

      if (config) {
        Object.entries(config).forEach(([key, value]) => {
          if (key === 'name') {
            this._name = config.name // TODO FileDocument - name
          } else if (key === 'props') {
            if (value && typeof value === 'object') {
              Object.entries(value).forEach(([propKey, propValue]) => {
                this.props[propKey] = propValue
              })
            }
          } else {
            this[key] = value // TODO перенести в props ? - lastReturn, description
          }
        })
      }
    }
  }

  get id () {
    if (this.document) {
      return this.document.id
    }
    return null
  }

  get parentsIds () {
    if (this.document) {
      return this.folderId != null ? this.folderId : -1
    } else if (this.file) {
      return null // TODO
    }
    return null
  }

  get name () {
    if (this._name) {
      return this._name
    } else if (this.file) {
      return this.file.name
    } else if (this.document) {
      return this.folderFileName || this.document.name
    }
    return null
  }

  set name (value) {
    if (this._name) {
      this._name = value
    } else if (this.file) {
      this.file.name = value
    } else if (this.document) {
      this.folderFileName ? this.folderFileName = value : this.document.name = value
    }
    this.$node.label = value
  }

  get contentType () {
    if (this.file) {
      return this.file.type || null
    } else if (this.document) {
      return this.document.contentType
    }
    return null
  }

  get createTime () {
    // if (this.file) {
    //   return this.originalTime
    // } else
    if (this.document) {
      if (this.document.visCreateTime) {
        return this.document.visCreateTime
      } else if (this.document.time) {
        return this.document.time
      }
    }
    return null
  }

  loadThumbnail (force) {
    if (!this.isToUpload) {
      imageThumbnailLoader.load(this, force)
    }
  }
}

export class FileFolder extends FileWrapper {
  constructor (folder, config) {
    super()

    this.type = 'folder'
    this.folder = folder

    if (config) {
      if (config.children) {
        this._node.children = config.children
      }
      if (config.hierarchy) {
        this.hierarchy = !!config.hierarchy
      }
      if (config.isToUpload) {
        this.isToUpload = true
      }
    }
  }

  get id () {
    return this.folder.id
  }

  get parentId () {
    return this.folder.parentId
  }

  get name () {
    return this.folder ? this.folder.name : null
  }

  set name (value) {
    if (this.folder) {
      this.folder.name = value
    }
    this.$node.label = value
  }

  get contentType () {
    return null
  }

  get createTime () {
    return null
  }
}

let newFileNodesKeysCounter = 0

function createFileNode (fileWrapper) {
  const node = {
    selectable: true,
    _file: fileWrapper,
    label: fileWrapper.name,
    children: null
  }
  if (fileWrapper.type === 'folder') {
    node.nodeKey = fileWrapper.id
    node.children = []
  } else {
    if (fileWrapper.document) {
      node.nodeKey = fileWrapper.document.relId
      if (fileWrapper.folderIndex != null) {
        node.nodeKey += '.' + fileWrapper.folderIndex
      }
    } else {
      node.nodeKey = 'file.new.' + (newFileNodesKeysCounter++)
    }
  }
  return node
}
